import { render } from "./EndpointCard.vue?vue&type=template&id=7dc2aaf8&scoped=true&ts=true"
import script from "./EndpointCard.vue?vue&type=script&lang=ts"
export * from "./EndpointCard.vue?vue&type=script&lang=ts"

import "./EndpointCard.vue?vue&type=style&index=0&id=7dc2aaf8&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dc2aaf8"]])

export default __exports__